interface ToastProps {
  message: string;
  visible: boolean;
}

export default function Toast({ message, visible }: ToastProps) {
  return (
    <div
      className={`fixed left-1/2 -translate-x-1/2 bottom-8 z-[60] transition-all duration-300 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-3 pointer-events-none'
      }`}
      role="status"
      aria-live="polite"
    >
      <div className="flex items-center gap-2 px-5 py-3 rounded-lg bg-background-100 border border-background-300 text-foreground-100 text-sm">
        <i className="ri-information-line text-primary-400 text-base"></i>
        {message}
      </div>
    </div>
  );
}